import React, { useEffect, useRef, useState, useCallback, memo } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { saveAs } from "file-saver";
import {withAuth} from "../../config/axios";
import { UAParser } from "ua-parser-js";


const DiaryStoryteller = ({
  reportId,
  data,
  sidebarCard,
  progress,
  audioUrl,
  showStoryteller,
  handleSideBarCard,
  handleStoryteller,
  scrollStoryteller,
  summaryText,
  storyLoading,
  isHide,
  storyPermission,
}) => {
  const [openStoryteller, setOpenStoryteller] = useState(false);
  const [height, setHeight] = useState(0);
  const [openLangDrop, setOpenLangDrop] = useState(false);
  const [selectLang, setSelectLang] = useState(
    localStorage.getItem("storyLang") || "English"
  );
  const [languages] = useState(["English", "French", "Chinese"]);
  const ref = useRef(null);




  const parseData = (text) => {
    text = text ? "\n\n**\n" + text : "";
    const sections = text?.split("\n\n")?.filter((section) => section?.trim());
    const result = sections?.map((section) => {
      const [heading, ...paragraphs] = section?.split("\n");
      return {
        heading: heading?.replace(/^\*/g, "")?.trim(), // Remove leading *
        paragraph: paragraphs?.join("\n")?.trim(),
      };
    });
    return result;
  };

  useEffect(() => {
    const calculateHeight = () => {
      const paraDetail =
        document?.getElementById("storyText")?.getBoundingClientRect()
          ?.height || {};
      setHeight(paraDetail);
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => {
      window.removeEventListener("resize", calculateHeight);
    };

    // eslint-disable-next-line
  }, [openStoryteller]);

  useEffect(() => {
    if (scrollStoryteller) {
      let screenWidth = window.innerWidth;
      const topOffset =
        document.getElementById("diamondStoryBox")?.getBoundingClientRect()
          .top +
        window.scrollY -
        100; // 50px offset from the top
      if (screenWidth < 768) {
        window.scrollTo({ top: topOffset, behavior: "smooth" });
      }
    }
    // eslint-disable-next-line
  }, [scrollStoryteller]);

  const handleOutsideClick = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpenLangDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

const handleDownload = async () => {
 if (!audioUrl) return;
    try {
      const response = await fetch(audioUrl);
      const blob = await response.blob();
      saveAs(blob, `FCRF Storyteller - ${data?.weight}ct ${data?.saturation} ${data?.colorName} ${data?.shape_name}.mp3`); // Downloads the file

      const formattedDate = new Date()
              .toLocaleString("he-IL", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: false,
                timeZone: "Asia/Jerusalem",
              })
              .replace(",", "");
            const ua = navigator.userAgent;
            const [ipResponse, uaResult] = await Promise.all([
              fetch("https://api.ipify.org?format=json"),
              new Promise((resolve) => resolve(new UAParser(ua).getResult())),
            ]);
      
            const { ip } = await ipResponse.json();


      const payload = {
              Tool: "Dairy",
              Action: "Storyteller Download",
              DateTime: formattedDate,
              ID: reportId?.postId || "",
              FileName: `FCRF Storyteller - ${data?.weight}ct ${data?.saturation} ${data?.colorName} ${data?.shape_name}.mp3`,
              URL: audioUrl,
              services: {
                IP: ip,
                "Operating System": uaResult.os.name,
                Browser: uaResult.browser.name,
                Device: uaResult.device.model || "Desktop/Laptop",
              },
            };
            await withAuth().post(
              `diamond/download-storyteller`,
              payload
            );
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <section
      className={`diary-card ${sidebarCard?.diamondStoryBox ? "show" : "hide"}`}
      id="diamondStoryBox"
    >
      {showStoryteller && <h4>The Storyteller</h4>}

      {!isHide && (
        <div className="mobile-hide-card-btn">
          <label className="diary-check-container">
            <input
              type="checkbox"
              id={`nav-diamondStoryBox`}
              name={`diamondStoryBox`}
              onChange={() =>
                handleSideBarCard(
                  "diamondStoryBox",
                  sidebarCard?.diamondStoryBox
                )
              }
              checked={sidebarCard?.diamondStoryBox}
            />
            <div className="checkmark"></div>
          </label>
        </div>
      )}
      {storyLoading && (
        <div className="diamond-progress-container">
          <div className="diamond-progress storyLoading-progress">
            <p className="text-center storyLoading-text">{progress}%</p>
            <ProgressBar now={progress} />
          </div>
          <p className="storyLoading-text">
            Please wait while we curate your diamond’s presentation
          </p>
        </div>
      )}

      {showStoryteller && (
        <div className="diamond-progress-container">
           <div className="storyteller-audio-download">
          <Button
          className="outline-btn pdf-btn" 
          onClick={handleDownload}

          >
          <DownloadIcon />
          </Button>
        </div>
          <AudioPlayer audioUrl={audioUrl} />
          <button
            onClick={() => setOpenStoryteller(!openStoryteller)}
            className={`${
              openStoryteller ? "d-none" : ""
            } diamond-story-btn bg-transparent border-0`}
          >
            Read the story
          </button>

          <div className={`${openStoryteller ? "d-none" : ""}`}>
            <div>
              <p className="diamond-dispclaimer">
                Information is provided by the FCRF and curated by AI, it may
                contain occasional inaccuracies.
              </p>
            </div>
          </div>
          <div
            className="dec-para-cause"
            style={{ height: `${openStoryteller ? `${height + 5}px` : "0px"}` }}
          >
            <div
              id="storyText"
              className={`${openStoryteller ? "" : "d-none"}`}
            >
              {parseData(summaryText)?.map((e, i) => (
                <div>
                  <h6>{e?.heading.slice(0, -1)}</h6>
                  <p>{e?.paragraph}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={() => setOpenStoryteller(!openStoryteller)}
            className={`${
              openStoryteller ? "" : "d-none"
            } diamond-story-btn bg-transparent border-0`}
          >
            Close
          </button>
          <div className={`${openStoryteller ? "" : "d-none"}`}>
            <div>
              <p className="diamond-dispclaimer">
                Information is provided by the FCRF and curated by AI, it may
                contain occasional inaccuracies.
              </p>
            </div>
          </div>
        </div>
      )}

      {!showStoryteller && !storyLoading && (
        <div>
          <div className="diamond-storyteller-container">
            <div className="storyteller-languages" ref={ref}>
              <div className="storyteller-beta">
                <p>[BETA]</p>
              </div>
              <Button
                className="outline-btn language-btn"
                onClick={() => setOpenLangDrop(!openLangDrop)}
                disabled={
                  showStoryteller ||
                  storyLoading ||
                  ((storyPermission?.diaryVoiceCredit === "0" ||
                    !storyPermission?.diaryVoiceCredit) &&
                    storyPermission?.diaryVoiceCredit !== "-1" &&
                    storyPermission?.role !== "administrator" &&
                    storyPermission?.role !== "contributor" &&
                    storyPermission?.role !== "pro_corporate_plus")
                }
              >
                <span>{selectLang}
                <div className="horizontal-line"></div>
                <div
                  className="down-arrow"
                  style={{ transform: openLangDrop ? "rotate(180deg)" : "" }}
                >
                  <DownArrow />
                </div>
                </span>
              </Button>
              {openLangDrop && (
                <div className="storyteller-languages-list">
                  {languages.map((listItem, i) => (
                    <p
                      key={i}
                      className={`storyteller-languages-list-item ${
                        selectLang === listItem ? "selected-language" : ""
                      }`}
                      onClick={() => {
                        setSelectLang(listItem);
                        localStorage.setItem("storyLang", listItem);
                        setOpenLangDrop(false);
                      }}
                    >
                      {listItem}
                    </p>
                  ))}
                </div>
              )}
            </div>

            <Button
              className="processBtn outline-btn diamond-new-report diamond-Storyteller"
              onClick={() => handleStoryteller(selectLang)}
              disabled={
                showStoryteller ||
                storyLoading ||
                ((storyPermission?.diaryVoiceCredit === "0" ||
                  !storyPermission?.diaryVoiceCredit) &&
                  storyPermission?.diaryVoiceCredit !== "-1" &&
                  storyPermission?.role !== "administrator" &&
                  storyPermission?.role !== "contributor" &&
                  storyPermission?.role !== "pro_corporate_plus")
              }
            >
              <span>The Storyteller</span>
              <SoundIcon />
            </Button>
          </div>
          {storyPermission?.role !== "administrator" &&
            storyPermission?.role !== "contributor" &&
            storyPermission?.role !== "pro_corporate_plus" &&
            storyPermission?.diaryVoiceCredit !== "-1" &&
            (storyPermission?.diaryVoiceCredit === "0" ||
            !storyPermission?.diaryVoiceCredit ? (
              <div className="storyteller-text-container">
                <h5 className="text-center">
                  Your trial sessions are completed.
                </h5>
                <h5 className="text-center">
                  Update to{" "}
                  <a
                    href={`${process.env.REACT_APP_WP_BASE_URL}/membership-plans`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Corporate
                  </a>{" "}
                  for unlimited storytelling support.
                </h5>
              </div>
            ) : (
              <div className="storyteller-text-container">
                <h5 className="text-center">
                  {storyPermission?.role?.split("_").join("-")} have{" "}
                  {parseInt(storyPermission?.diaryVoiceCredit) || 0} Storyteller
                  sessions to enrich your diamond{" "}
                </h5>
                <h5 className="text-center">
                  knowledge and build client trust. (
                  {parseInt(storyPermission?.diaryVoiceCreditUses) || 0}/
                  {(parseInt(storyPermission?.diaryVoiceCredit) || 0) +
                    (parseInt(storyPermission?.diaryVoiceCreditUses) || 0)}
                  )
                </h5>
              </div>
            ))}
        </div>
      )}
    </section>
  );
};

export default DiaryStoryteller;

const AudioPlayer = memo(({ audioUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const handlePlayPause = useCallback(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying((prev) => !prev);
    }
  }, [isPlaying]);

  const handleSkipForward = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime += 10;
    }
  }, []);

  const handleSkipBackward = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime -= 10;
    }
  }, []);

  const handleSliderChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      if (audioRef.current) {
        audioRef.current.currentTime = (newValue / 100) * duration;
      }
    },
    [duration]
  );

  const updateCurrentTime = useCallback(() => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  }, []);

  const handleLoadedMetadata = useCallback(() => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  }, []);

  const progress = (currentTime / duration) * 100 || 0;

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.addEventListener("timeupdate", updateCurrentTime);
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("ended", () => setIsPlaying(false));

    return () => {
      audio.removeEventListener("timeupdate", updateCurrentTime);
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("ended", () => setIsPlaying(false));
    };
  }, [updateCurrentTime, handleLoadedMetadata]);

  return (
    <div className="diamond-progress">
      <audio ref={audioRef} src={audioUrl} />
      <div className="diamond-play-btn d-flex justify-content-center mb-4 gap-5 align-items-center">
        <button
          onClick={handleSkipBackward}
          className="border-0 bg-transparent"
        >
          <LeftPlaybtn />
        </button>
        <button onClick={handlePlayPause} className="border-0 bg-transparent">
          {isPlaying ? <PlaynBtn /> : <PauseBtn />}
        </button>
        <button onClick={handleSkipForward} className="border-0 bg-transparent">
          <RightPlaybtn />
        </button>
      </div>
      <div>
        <div className="range-diamond-input">
          <div className={`range w-100`}>
            <input
              type="range"
              min={0}
              max={100}
              value={progress}
              onChange={handleSliderChange}
              style={{
                background: `linear-gradient(to right, #BF8F02 ${progress}%, #e9ecef ${progress}%)`,
              }}
            />
            <div className="dots">
              {[0, 1, 2, 3].map((dotIndex) => (
                <span
                  key={dotIndex}
                  className="slider-dot"
                  style={{ left: `${dotIndex * 25}%` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const LeftPlaybtn = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77637 4.77588V0.775879L3.77637 5.77588L8.77637 10.7759V6.77588C12.0864 6.77588 14.7764 9.46588 14.7764 12.7759C14.7764 16.0859 12.0864 18.7759 8.77637 18.7759C5.46637 18.7759 2.77637 16.0859 2.77637 12.7759H0.776367C0.776367 17.1959 4.35637 20.7759 8.77637 20.7759C13.1964 20.7759 16.7764 17.1959 16.7764 12.7759C16.7764 8.35588 13.1964 4.77588 8.77637 4.77588ZM7.67637 15.7759H6.82637V12.5159L5.81637 12.8259V12.1359L7.58637 11.5059H7.67637V15.7759ZM11.9564 14.0159C11.9564 14.3359 11.9264 14.6159 11.8564 14.8359C11.7864 15.0559 11.6864 15.2559 11.5664 15.4059C11.4464 15.5559 11.2864 15.6659 11.1164 15.7359C10.9464 15.8059 10.7464 15.8359 10.5264 15.8359C10.3064 15.8359 10.1164 15.8059 9.93637 15.7359C9.75637 15.6659 9.60637 15.5559 9.47637 15.4059C9.34637 15.2559 9.24637 15.0659 9.17637 14.8359C9.10637 14.6059 9.06637 14.3359 9.06637 14.0159V13.2759C9.06637 12.9559 9.09637 12.6759 9.16637 12.4559C9.23637 12.2359 9.33637 12.0359 9.45637 11.8859C9.57637 11.7359 9.73637 11.6259 9.90637 11.5559C10.0764 11.4859 10.2764 11.4559 10.4964 11.4559C10.7164 11.4559 10.9064 11.4859 11.0864 11.5559C11.2664 11.6259 11.4164 11.7359 11.5464 11.8859C11.6764 12.0359 11.7764 12.2259 11.8464 12.4559C11.9164 12.6859 11.9564 12.9559 11.9564 13.2759V14.0159ZM11.1064 13.1559C11.1064 12.9659 11.0964 12.8059 11.0664 12.6759C11.0364 12.5459 10.9964 12.4459 10.9464 12.3659C10.8964 12.2859 10.8364 12.2259 10.7564 12.1959C10.6764 12.1659 10.5964 12.1459 10.5064 12.1459C10.4164 12.1459 10.3264 12.1659 10.2564 12.1959C10.1864 12.2259 10.1164 12.2859 10.0664 12.3659C10.0164 12.4459 9.97637 12.5459 9.94637 12.6759C9.91637 12.8059 9.90637 12.9659 9.90637 13.1559V14.1259C9.90637 14.3159 9.91637 14.4759 9.94637 14.6059C9.97637 14.7359 10.0164 14.8459 10.0664 14.9259C10.1164 15.0059 10.1764 15.0659 10.2564 15.0959C10.3364 15.1259 10.4164 15.1459 10.5064 15.1459C10.5964 15.1459 10.6864 15.1259 10.7564 15.0959C10.8264 15.0659 10.8964 15.0059 10.9464 14.9259C10.9964 14.8459 11.0364 14.7359 11.0564 14.6059C11.0764 14.4759 11.0964 14.3159 11.0964 14.1259V13.1559H11.1064Z"
        fill="#2D3653"
      />
    </svg>
  );
};

const RightPlaybtn = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4226 12.7759C14.4226 16.0859 11.7326 18.7759 8.42261 18.7759C5.11261 18.7759 2.42261 16.0859 2.42261 12.7759C2.42261 9.46588 5.11261 6.77588 8.42261 6.77588V10.7759L13.4226 5.77588L8.42261 0.775879V4.77588C4.00261 4.77588 0.422607 8.35588 0.422607 12.7759C0.422607 17.1959 4.00261 20.7759 8.42261 20.7759C12.8426 20.7759 16.4226 17.1959 16.4226 12.7759H14.4226Z"
        fill="#2D3653"
      />
      <path
        d="M7.28261 15.7159V11.4459H7.19261L5.42261 12.0759V12.7659L6.43261 12.4559V15.7159H7.28261ZM8.67261 13.2159V13.9559C8.67261 15.8559 9.98261 15.7759 10.1126 15.7759C10.2526 15.7759 11.5526 15.8659 11.5526 13.9559V13.2159C11.5526 11.3159 10.2426 11.3959 10.1126 11.3959C9.97261 11.3959 8.67261 11.3059 8.67261 13.2159ZM10.7126 13.0959V14.0659C10.7126 14.8359 10.5026 15.0959 10.1226 15.0959C9.74261 15.0959 9.52261 14.8359 9.52261 14.0659V13.0959C9.52261 12.3459 9.74261 12.0859 10.1126 12.0859C10.4926 12.0759 10.7126 12.3459 10.7126 13.0959Z"
        fill="#2D3653"
      />
    </svg>
  );
};

const PauseBtn = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6736 12.3503L6.31203 22.374L6.31203 2.32655L23.6736 12.3503Z"
        fill="#2D3653"
      />
    </svg>
  );
};

const PlaynBtn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="currentColor"
      class="bi bi-pause"
      viewBox="0 0 16 16"
    >
      <path
        d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5"
        fill="#2D3653"
      />
    </svg>
  );
};

const SoundIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.80327 15.9176C10.3722 15.9176 10.7822 15.499 10.7822 14.9383V1.5872C10.7822 1.02648 10.3722 0.557556 9.78613 0.557556C9.37613 0.557556 9.10827 0.758628 8.65613 1.16041L4.7222 4.65077C4.67184 4.70077 4.59648 4.72613 4.51291 4.72613H2.02684C0.838269 4.72613 0.252197 5.32041 0.252197 6.58434V9.91613C0.252197 11.1804 0.837912 11.7743 2.02684 11.7743H4.51255C4.59648 11.7743 4.67184 11.7993 4.7222 11.8497L8.65613 15.374C9.06648 15.7418 9.39291 15.9179 9.80291 15.9179M17.0351 14.2104C17.3611 14.4279 17.7629 14.3443 17.9976 14.0093C19.1022 12.4693 19.7468 10.4186 19.7468 8.27577C19.7468 6.12434 19.1108 4.07363 17.9976 2.53327C17.7547 2.20684 17.3611 2.12327 17.0347 2.34077C16.7168 2.55863 16.6665 2.96863 16.9176 3.32863C17.8301 4.66791 18.3993 6.42577 18.3993 8.27577C18.3993 10.1258 17.8468 11.9001 16.9176 13.2226C16.6747 13.5826 16.7172 13.9926 17.0351 14.2104ZM9.31684 14.1518C9.27505 14.1518 9.2247 14.1268 9.17434 14.0765L5.46755 10.7361C5.26648 10.5518 5.09898 10.5101 4.87327 10.5101H2.08541C1.75898 10.5101 1.5997 10.3593 1.5997 10.0243V6.47541C1.5997 6.14898 1.75898 5.99006 2.08541 5.99006H4.87291C5.09863 5.99006 5.25791 5.95648 5.4672 5.76398L9.17505 2.39899C9.2172 2.36577 9.2672 2.3322 9.31755 2.3322C9.39255 2.3322 9.4347 2.3822 9.4347 2.44934V14.0258C9.4347 14.1011 9.39291 14.1515 9.31755 14.1515M13.6954 11.9501C13.9801 12.1508 14.3901 12.0836 14.6329 11.7572C15.2858 10.8786 15.6793 9.58934 15.6793 8.27506C15.6793 6.96077 15.2776 5.68041 14.6329 4.7847C14.3901 4.45827 13.9883 4.39113 13.6954 4.59184C13.3268 4.8347 13.2851 5.26184 13.5529 5.63006C14.0386 6.28291 14.3315 7.27898 14.3315 8.27506C14.3315 9.27148 14.0218 10.2676 13.5447 10.9286C13.2936 11.2886 13.3354 11.6986 13.6954 11.9501Z"
        fill="#bf8f02"
      />
    </svg>
  );
};

const DownArrow = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66846 5.6604L0.637368 0.410401L6.69955 0.4104L3.66846 5.6604Z"
        fill="#BF8F02"
      />
    </svg>
  );
};


const DownloadIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.156 15.242c.232 0 .447.097.6.25A.9.9 0 0 1 21 16.1v3.991l-.008.115-.02.107a.856.856 0 0 1-.833.687H3.856a.853.853 0 0 1-.845-.76C3 20.187 3 20.142 3 20.085v-3.992c0-.471.385-.852.85-.852a.852.852 0 0 1 .85.852v3.197h14.605v-3.197c0-.471.386-.852.85-.852zM12.01 3c.272 0 .522.114.703.29a.983.983 0 0 1 .29.704v9.215l2.51-2.515a.998.998 0 0 1 1.405 0 1.018 1.018 0 0 1-.017 1.408l-4.177 4.185c-.005.011-.017.017-.022.023a.984.984 0 0 1-.55.278c-.017 0-.034.006-.051.006l-.051.005H12l-.096-.005c-.017 0-.034-.006-.051-.006a.966.966 0 0 1-.55-.278l-.023-.023-4.177-4.185a.994.994 0 0 1-.289-.704c0-.255.097-.51.29-.704a.998.998 0 0 1 1.405 0l2.51 2.515V3.994c0-.545.448-.994.992-.994z"
        fill="#bf8f02"
        fillRule="evenodd"
      />
    </svg>
  );
};